import { openDashboardPath } from '@/contexts/AuthContext';
import { portalPath, type PortalKind } from '@/utils/portalRouting';

/**
 * Open a portal. Admin is the Laravel staff dashboard, not an in-app SPA page.
 */
export function goToPortal(
  portal: PortalKind,
  navigate: (to: string, options?: { replace?: boolean }) => void,
): void {
  if (portal === 'admin') {
    void openDashboardPath('/');
    return;
  }
  navigate(portalPath(portal));
}
